module.exports = __webpack_public_path__ + "img/skinwash_step3.f81cfd22.jpg";